import { TabsListCombinedProps } from './types';

const usePresenter = (props: TabsListCombinedProps): TabsListCombinedProps => {
  return props;
};

export default usePresenter;
